

export function makeCallbackUrl(callbackUrl, currentUrl, refer, page) {
  let urlRaw = callbackUrl
  if (!urlRaw) {
    urlRaw = currentUrl
  }

  let url = new URL(urlRaw)
  if (refer) {
    url.searchParams.set("refer", refer)
  }

  if (page) {
    url.searchParams.set("page", page)
  }

  url.searchParams.set("_r_source", 'pay')
  url.searchParams.delete("_pay_canceled")
  url.searchParams.delete("code")
  url.searchParams.delete("state")
  url.searchParams.delete("source")
  return url.toString()
}
